// src/index.js (example)
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import './styles/grid.css';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Provider, useDispatch } from 'react-redux';
import store from './redux/store';
import { loadUser, refreshAccessToken } from './redux/auth/authSlice';

// Import your route components
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute'; 
import LoginForm from './components/LoginForm';
import Tasks from './pages/Tasks';
import Users from './pages/Admin/Users.jsx';
import TaskSubmitted from './components/TaskSubmitted.jsx';
import Documents from './pages/Documents.jsx';
import Feedbacks from './pages/Feddbacks.jsx';
import Dashboard from './components/Dashboard.jsx';
import FeedbackView from './components/Feedbacks/FeedbackView.jsx';
import UsersPerformance from './components/Admin/Users/UsersPerfomance.jsx';
import LandingPage from './pages/Landing/LandingPage';
import TaskHistory from './pages/TaskHistory';

// Create the router
const router = createBrowserRouter([
  { path: "/", element: <LandingPage /> },
  { path: "/login", element: <LoginForm /> },
  { 
    path: "/dashboard",
    element: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
  },
  { 
    path: "/tasks/:id?",
    element: (
      <PrivateRoute>
        <Tasks />
      </PrivateRoute>
    ),
  },
  {
    path: "/task-history",
    element: (
      <PrivateRoute>
        <TaskHistory />
      </PrivateRoute>
    ),
  },
  {
    path: "/users",
    element: (
      <AdminRoute>
        <Users />
      </AdminRoute>
    ),
  },
  {
    path: "/users-perfomance/:id",
    element: (
      <AdminRoute>
        <UsersPerformance />
      </AdminRoute>
    ),
  },
  {
    path: "/submitted",
    element: (
      <PrivateRoute>
        <TaskSubmitted />
      </PrivateRoute>
    ),
  },
  {
    path: "/document",
    element: (
      <PrivateRoute>
        <Documents />
      </PrivateRoute>
    ),
  },
  {
    path: "/feedback",
    element: (
      <PrivateRoute>
        <Feedbacks />
      </PrivateRoute>
    ),
  },
  {
    path: "/feedback-view/:id",
    element: (
      <PrivateRoute>
        <FeedbackView />
      </PrivateRoute>
    ),
  },
]);

function App() {
  const dispatch = useDispatch();

  React.useEffect(() => {
    // 1) Attempt to refresh the token
    dispatch(refreshAccessToken())
      .unwrap()
      .then((newAccessToken) => {
        // 2) If refresh success, load user
        if (newAccessToken) {
          dispatch(loadUser({ accessToken: newAccessToken }));
        }
      })
      .catch(() => {
        // Silent handling of refresh failures - expected for new visitors
        // We just remain logged out without error messaging
      });
  }, [dispatch]);

  // Provide the router
  return <RouterProvider router={router} />;
}

// Render
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();